export const experiences = [
    {
        "title": "Co-op position at Accumine Technologies",
        "date": "2019-2020",
        "desc": "This was my first real experience in software development; I contributed to the codebase on my company's private BitBucket repository and planned various projects with my supervisors. I also used ReactJS and CouchDB to create an internal employee agenda application.",
        "image": "AccumineBanner.png"
    },
    {
        "title": "Competitive programming",
        "date": "2017-2021",
        "desc": "I've participated in the University of Waterloo's Canadian Computing Competition since 2017, and earned certificates of distinction for two Junior competitions and one Senior competition. I've also participated in other minor contests on DMOJ.ca to practice my competitive programming skills.",
        "image": "CompetitiveProgrammingBanner.png"

    },
    {
        "title": "Game development hobbyist",
        "date": "2020-present",
        "desc": "During the quarantine, I started learning game development as a hobby and experimented with frameworks such as LibGDX. I've spent the majority of my time using Unity and C#, and I've participated in a few game jams and created several side projects.",
        "image": "GameDevelopmentBanner.jpg"

    }
]